/* ============================================================
   HORCERY — Accordion groups: single-open (opening one closes the
   others) + auto-close everything once the group scrolls a
   reasonable distance out of view. Progressive enhancement over
   native <details>; no-JS keeps them all independently toggleable.
   Wire a group by adding data-hz-accordions to the container whose
   direct/descendant <details> should behave as one set.
   ============================================================ */
(function () {
  'use strict';

  function initGroup(group) {
    if (group.__hzAcc) return;
    group.__hzAcc = true;
    var items = Array.prototype.slice.call(group.querySelectorAll('details'));
    if (!items.length) return;

    // Single-open: when one opens, close its siblings.
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d && o.open) o.open = false; });
      });
    });

    // Auto-close all when the group scrolls out of view (a reasonable distance away).
    if ('IntersectionObserver' in window && !group.hasAttribute('data-hz-no-scroll-close')) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) {
            items.forEach(function (o) { if (o.open) o.open = false; });
          }
        });
      }, { root: null, rootMargin: '0px', threshold: 0 });
      io.observe(group);
    }
  }

  function initAll() { document.querySelectorAll('[data-hz-accordions]').forEach(initGroup); }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
